import LoadingSpinner from "../../../../components/LoadingSpinner";

export default function ConfirmModal({ open, title, message, onConfirm, onCancel, isLoading }) {
    if (!open) return null;

    return (
        <div className='fixed inset-0 z-[1000] flex items-center justify-center bg-black/50'>
            <div className='w-[420px] max-w-[90vw] bg-white rounded-md shadow-lg p-4'>
                <h3 className='mb-2 text-lg font-semibold text-center text-gray-800'>{title}</h3>

                <p className='text-sm text-center text-gray-700'>{message}</p>

                <div className='flex gap-3 justify-center mt-4'>
                    <button
                        type='button'
                        onClick={onCancel}
                        className='px-4 py-1.5 bg-white rounded border border-gray-300 hover:bg-gray-50'
                    >
                        Cancel
                    </button>

                    <button
                        type='button'
                        onClick={onConfirm}
                        className='px-4 py-1.5 text-white rounded bg-blue-primary hover:bg-blue-700'
                    >
                        {isLoading ? <LoadingSpinner className='w-22' spinnerSize={'8'} /> : 'Yes'}
                    </button>
                </div>
            </div >
        </div >
    );
}
